
//these are the guides/rails
//eg center line control
const Guides = ({guides,scale,ratio})=>{
	if (!guides) return null
	return (
		<>
			{Boolean(guides.center)&&
				<>
					<line 
						x1={guides.center.left*scale} y1={0} 
						x2={guides.center.left*scale} y2={320*ratio*scale} 
						stroke={"rgba(255,255,255,0.76"}
						strokeWidth={4}
					/>
					<line 
						x1={guides.center.right*scale} y1={0} 
						x2={guides.center.right*scale} y2={320*ratio*scale} 
						stroke={"rgba(255,255,255,0.76"}
						strokeWidth={4}
					/>
				</>
			}
			{Boolean(guides.ankleBottomY)&&
				<line 
					x1={0} y1={guides.ankleBottomY*scale} 
					x2={320*scale} y2={guides.ankleBottomY*scale} 
					stroke="rgba(255,255,255,0.6)"
					strokeWidth={4}
				/>
			}
		</>
	)
}

export default Guides